import { c as _c } from "react/compiler-runtime";
import { type DateFormatPattern, isoDateToUserDateLocale } from '@onefootprint/core';
import { useTranslation } from 'react-i18next';

// A day past 12 can't be read as a month, so the example alone gives away the order.
const EXAMPLE_DATE = '1990-12-31';

/** The placeholder vanishes on the first keystroke, so outside MM/DD/YYYY the order stays on screen. */
const useDateExampleHint = pattern => {
  const $ = _c(3);
  const {
    t
  } = useTranslation("ui");
  let t0;
  if ($[0] !== pattern || $[1] !== t) {
    t0 = t("components.form.date.example-hint", {
      example: isoDateToUserDateLocale(EXAMPLE_DATE, pattern)
    });
    $[0] = pattern;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const hint = t0;
  return pattern === "mdy" ? undefined : hint;
};
export default useDateExampleHint;